import { isExternalImageSource, isSupportedImageType } from '@nubank/www-latam-commons/components/Image/utils';

import { resolveCMSImagePath } from './cms/images/resolveCMSImage';
import isCMSImage from './cms/images/isCMSImage';

const isTestEnv = process.env.NODE_ENV === 'test';

export function requireImage(path, format) {
  const isSupportedFormat = isSupportedImageType(format);

  if (isCMSImage(path)) {
    return resolveCMSImagePath(path, format);
  }

  if (isExternalImageSource(path)) {
    return path;
  }

  if (isSupportedFormat) {
    return isTestEnv ? `public/images/${path}.webp` : require(`public/images/${path}?webp`);
  }

  return isTestEnv ? `public/images/${path}` : require(`public/images/${path}`);
}
